import { useCallback } from 'react';
import { useTableContext } from '@experiences/components/table/blocs/table-context';
import { useTableFocusStore } from '@experiences/components/table/blocs/stores/table-focus-store';

/**
 * Returns a callback that an editable cell should fire on focus. Records
 * the focused row in the table-focus store, which drives the parent
 * table's auto-scroll-to-focused-row behavior. When `columnId` is given,
 * also scrolls the table horizontally to reveal that column (native only).
 * Pair with {@link useIsTableScrollSettled} to hold focus-driven UI until the
 * scroll finishes.
 */
export const useReportCellFocus = (rowIndex: number, columnId?: string) => {
  const { beginFocusSettle, scrollToColumn, tableId } = useTableContext();
  return useCallback(() => {
    useTableFocusStore.getState().setFocusedIndex(tableId, rowIndex);
    beginFocusSettle?.();
    if (columnId) {
      scrollToColumn?.(columnId);
    }
  }, [beginFocusSettle, columnId, rowIndex, scrollToColumn, tableId]);
};
